/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCarePatientDetails } from './MatrixCarePatientDetails';
import {
    MatrixCarePatientDetailsFromJSON,
    MatrixCarePatientDetailsFromJSONTyped,
    MatrixCarePatientDetailsToJSON,
    MatrixCarePatientDetailsToJSONTyped,
} from './MatrixCarePatientDetails';

/**
 * 
 * @export
 * @interface FindOneMatrixCarePatientDetails200Response
 */
export interface FindOneMatrixCarePatientDetails200Response {
    /**
     * 
     */
    data?: MatrixCarePatientDetails;
}

/**
 * Check if a given object implements the FindOneMatrixCarePatientDetails200Response interface.
 */
export function instanceOfFindOneMatrixCarePatientDetails200Response(value: object): value is FindOneMatrixCarePatientDetails200Response {
    return true;
}

export function FindOneMatrixCarePatientDetails200ResponseFromJSON(json: any): FindOneMatrixCarePatientDetails200Response {
    return FindOneMatrixCarePatientDetails200ResponseFromJSONTyped(json, false);
}

export function FindOneMatrixCarePatientDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneMatrixCarePatientDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MatrixCarePatientDetailsFromJSON(json['data']),
    };
}

export function FindOneMatrixCarePatientDetails200ResponseToJSON(json: any): FindOneMatrixCarePatientDetails200Response {
    return FindOneMatrixCarePatientDetails200ResponseToJSONTyped(json, false);
}

export function FindOneMatrixCarePatientDetails200ResponseToJSONTyped(value?: FindOneMatrixCarePatientDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MatrixCarePatientDetailsToJSON(value['data']),
    };
}

